/** App IDs returned by the Company API (`Users/{id}` → `apps[].id`) — must match CompanyMgmt.API's `Apps` enum. */
export enum Apps {
  Unknown = 0,
  TPMPortal = 1,
  POS = 2,
  Donation = 3,
  Lister = 4,
  AdminPortal = 5,
  CompanyPortal = 6,
  Inventory = 7,
  Consignment = 8
}

export const AppsLabel: Record<Apps, string> = {
  [Apps.Unknown]: 'Unknown',
  [Apps.TPMPortal]: 'TPM',
  [Apps.POS]: 'POS',
  [Apps.Donation]: 'Donation',
  [Apps.Lister]: 'Lister',
  [Apps.AdminPortal]: 'Admin Portal',
  [Apps.CompanyPortal]: 'Company',
  [Apps.Inventory]: 'Inventory',
  [Apps.Consignment]: 'Consignment'
};
